module.exports = __webpack_public_path__ + "static/media/Offer (active).a6c37c43.svg";